module.exports = __webpack_public_path__ + "static/media/ic_phone.d262c8b4.svg";